import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import './Collapsible.css';
import './formAvis.css';
import axios from "axios";
import StarRating from "./StarRating";

export default function FormAvis() {
  const [rating, setRating] = useState(3);
  const [emailOccurences,setEmailOccurences] = useState(0);
  const [errors, setErrors] = useState({});
  const [countChar, setCountChar] = useState(0);

  const [avis, setAvis] = useState({
    nom_utilisateur: "",
    email:"",
    note:rating,
    message:"",
  });


  
  const navigate = useNavigate();

  const handleChange = (e) =>{
    avis.note = rating;
    setAvis(prev=>({...prev, [e.target.name]: e.target.value }));
    setCountChar(avis.message.length);

  }

  // Fonction envoyant les données au serveur Node
  const sendAvis = async e => {

    e.preventDefault();
    const email = avis.email;
    const resultGet = await axios.get("https://astraya.ch:4005/check",{
      params: {
        email: email,
      }
    });

    setEmailOccurences(resultGet.data.length);
    const newErrors = validateForm(avis, emailOccurences);
    setErrors(newErrors);


    if (Object.keys(newErrors).length === 0) 
    {
      try
      {
        await axios.post("https://astraya.ch:4005/avis",avis);
        window.location.reload()
      }
      catch(err)
      {
        console.log(err);
      }
    } 
    else 
    {
        console.log('Form submission failed due to validation errors.');
        // emailLabelStyle = {backgroundColor:"#ecaaaa"};      
        // emailOccurences > 0 ? erreurMail = "Cet email existe déjà" : erreurMail = "votre email n'est pas valide";
    }
 
  }

    // fonction vérifiant si il y a des erreur dans le formulaire
    const validateForm = (data, dbEmailExists) => {
      const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      const errors = {};

      if (data.nom_utilisateur ==="" || data.nom_utilisateur === undefined) {
          errors.nom_utilisateur = 'Veuillez entrer votre nom et prénom';
      }

      if (data.email ==="" || data.email === undefined) {
          errors.email = 'Veuillez entrer votre email';
      } else if (!data.email.toLowerCase().match(re)) {
          errors.email = "Email n'est pas valide";
      } else if (dbEmailExists > 0){
          errors.email = "Cet email est déjà enregistré"
      }

      if (countChar > 100) {
          errors.message = 'Votre commentaire doit faire moins de 100 caractères';
      }
      return errors;
  };  
      
  return (
    <div>
        <div className='formulaireContact'>
            <form className="contact-form">
            <StarRating className="etoiles" rating={rating} setRating={setRating}></StarRating>
            <input hidden type="number" onChange={handleChange} name="note" value={rating}></input>
            <label>Nom & Prénom</label>
            <input type="text" name="nom_utilisateur" maxLength="100" onChange={handleChange}/>
            {errors.nom_utilisateur && (
                        <p className="error-message">
                            {errors.nom_utilisateur}
                        </p>
                    )}
            <label>Email</label>
            <input type="text" name="email" onChange={handleChange} />
            {errors.email && (
                        <p className="error-message">
                            {errors.email}
                        </p>
                    )}
            <label>Message</label> 
            <textarea name="message" onChange={handleChange} />
            <div className="message-label-container">
              <div className="textarea-error-message">
              {errors.message && (
                        <p className="error-message">
                            {errors.message}
                        </p> 
                    )}
              </div>
            <label className="char-count">{countChar}/100</label>
            </div>
            <button className="custom-submit" onClick={sendAvis}>Envoyer</button>
            </form>
        </div>
    </div>
    
  );
}